<template>
	<svg
		width="19px"
		height="12px"
		viewBox="0 0 19 12"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		alt="record video icon"
	>
		<g
			id="RecordVideo"
			stroke="none"
			stroke-width="1"
			fill="none"
			fill-rule="evenodd"
		>
			<g
				id="Livestream---Grid"
				transform="translate(-954.000000, -24.000000)"
				fill="#ffffff"
			>
				<g id="Group" transform="translate(946.000000, 14.000000)">
					<path
						d="M22.25,19.6680001 C22.25,20.9559281 21.2059281,22 19.9180001,22 L10.3319999,22 C9.04407193,22 8,20.9559281 8,19.6680001 L8,12.3319999 C8,11.0440719 9.04407193,10 10.3319999,10 L19.9180001,10 C21.2059281,10 22.25,11.0440719 22.25,12.3319999 L22.25,13.6 L25.3081717,12.0548185 C25.8829355,11.7644115 26.584295,11.9949283 26.874702,12.5696921 C26.9570807,12.7327335 27,12.9128493 27,13.0955204 L27,18.9044796 C27,19.5484436 26.477964,20.0704795 25.834,20.0704795 C25.6513289,20.0704795 25.4712131,20.0275603 25.3081717,19.9451815 L22.25,18.4 L22.25,19.6680001 Z M15.125,13.6 C13.8133237,13.6 12.75,14.6745166 12.75,16 C12.75,17.3254834 13.8133237,18.4 15.125,18.4 C16.4366763,18.4 17.5,17.3254834 17.5,16 C17.5,14.6745166 16.4366763,13.6 15.125,13.6 Z"
						id="Record-Video"
					></path>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	Name: 'RecordVideo',
}
</script>
